import React from "react";
import FileUpload from "../../Common/FileUpload";

const MarketingMaterialsUpload = (props: { values: any; setFieldValue: any, jobId:any }) => {
  const { values, setFieldValue,jobId } = props;

  return (
    <FileUpload
      jobId={jobId}
      values={values}
      setFieldValue={setFieldValue}
      fieldName="marketingMaterialPresent"
      label="Add picture of marketing materials present (attachments)"
    />
  );
};

export default MarketingMaterialsUpload;